export default __webpack_public_path__ + "static/media/dmy2.5931c902.png";